import { useEffect } from "react";

import ResultField from "@/components/Calculator/Components/ResultField/resultField.component";
import ResultTitle from "@/components/Calculator/Components/ResultTitle/resultTitle.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";

import { GravelShoppingList } from "../gravelCalculator.types";

type ResultComponentProps = {
    result: GravelShoppingList;
    mailParams: Record<string, string>;
};

const ResultComponent = ({ result, mailParams }: ResultComponentProps) => {
    const { t } = useGranite();
    const { volume, bags, kgGravel } = result;

    useEffect(() => {
        CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.gravel);
    }, []);

    return (
        <div id="result">
            <ResultTitle mailParams={mailParams} />
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t("calculator.gravelCalculator.volume")}
                    unit={"m"}
                    sup={3}
                    value={volume.toFixed(2)}
                />
            </Row>
            <Row>
                <Col>
                    <h4 className="d-sm-block">{t("calculator.supplies")}</h4>
                </Col>
            </Row>
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t("calculator.gravelCalculator.totalWeight")}
                    unit={"kg"}
                    value={kgGravel.toFixed(0)}
                />
            </Row>
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t(
                        "calculator.gravelCalculator.totalBagsUnit",
                        bags.weight
                    )}
                    value={bags.amount.toFixed(0)}
                />
            </Row>
            <Row>
                <Col>
                    <p>{t("calculator.gravelCalculator.info")}</p>
                </Col>
            </Row>
        </div>
    );
};

export default ResultComponent;
